

const NotFoundPage = () => {

    return (
        <>not found page</>
    )
}

export { NotFoundPage }